import {AxiosError} from 'axios';
import {useCustomMutation} from '../utils/useCustomMutation';
import axiosClient from '../axiosClient';
import {PUT_REGISTRATION_PARTICULARS_URL} from '../../constants/apiUrls';
import {IExamMasterCodeItem} from '../../api/user/model';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface PutRegistrationParticularsRequest {
  email?: string;

  // addresses
  mailingAddress?: {
    houseOrBlockNumber?: string;
    floorNumber?: string;
    unitNumber?: string;
    buildingName?: string;
    streetName?: string;
    postalCode?: string;
  };
  foreignAddress1?: string;
  foreignAddress2?: string;
  foreignAddress3?: string;
  localAddressPreferred?: boolean;

  // contact numbers
  telephoneNumber?: {
    countryCode?: IExamMasterCodeItem | null;
    number?: string;
  };
  mobileNumber?: {
    countryCode?: IExamMasterCodeItem;
    number?: string;
  };
  mobileNumberPreferred?: boolean;

  // next of kin
  nextOfKinName?: string;
  nextOfKinRelationship?: string;
  nextOfKinContactNumber?: {
    countryCode?: IExamMasterCodeItem;
    number?: string;
  };
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: (res: void) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePutRegistrationParticulars = ({uuid, onSuccess, onError}: Input) => {
  const putRegistrationParticulars = async (reqBody: PutRegistrationParticularsRequest) => {
    await axiosClient.put(PUT_REGISTRATION_PARTICULARS_URL(uuid), reqBody, {timeout: 20000});
  };

  return useCustomMutation(putRegistrationParticulars, {
    onSuccess,
    onError,
  });
};
